module.exports = __webpack_public_path__ + "static/android_3_EN-0f2a4ea92f386c599463daf783e074de.jpg";